import React from 'react';

import { ratio } from '../utils';

const PressureGauge: React.FC<{ hpa: number | null }> = ({ hpa }) => {
    // 970 hPa (deep low) .. 1050 hPa (strong high)
    const t = ratio(hpa, 970, 1050);

    return (
        <svg className="gauge" viewBox="0 0 120 66" aria-hidden="true">
            <defs>
                <linearGradient id="gauge-fill" x1="0" y1="0" x2="1" y2="0">
                    <stop offset="0" stopColor="#7dd3fc" />
                    <stop offset="0.5" stopColor="#a7f3d0" />
                    <stop offset="1" stopColor="#fcd34d" />
                </linearGradient>
            </defs>
            <path d="M10 60 A50 50 0 0 1 110 60" className="gauge-track" />
            <path d="M10 60 A50 50 0 0 1 110 60" className="gauge-arc" />
            <g className="gauge-marker" style={{ transform: `rotate(${t * 180}deg)` }}>
                <circle cx="10" cy="60" r="6" />
            </g>
        </svg>
    );
};

export default PressureGauge;
